import { render, staticRenderFns } from "./DiceRollPopUp.vue?vue&type=template&id=2f7eed2a&scoped=true"
import script from "./DiceRollPopUp.vue?vue&type=script&lang=ts"
export * from "./DiceRollPopUp.vue?vue&type=script&lang=ts"
import style0 from "./DiceRollPopUp.vue?vue&type=style&index=0&id=2f7eed2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7eed2a",
  null
  
)

export default component.exports